/* momomoca — global theme behavior. Vanilla JS, no build step. */
(function () {
  'use strict';

  var routes = { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartGet: '/cart.js', cartUpdate: '/cart/update.js', cartUrl: '/cart' };

  /* ---------------- Mobile nav ---------------- */
  var menuToggle = document.querySelector('.site-header__menu-toggle');
  var mobileNav = document.getElementById('MobileNav');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');

  function openMobileNav() {
    mobileNav.hidden = false;
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    mobileNavClose.focus();
  }
  function closeMobileNav() {
    mobileNav.hidden = true;
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    menuToggle.focus();
  }
  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && !mobileNav.hidden) closeMobileNav();
  });

  /* groups render open, so this only ever collapses. The submenu is no longer
     the button's sibling -- the button sits next to the parent link inside a
     row -- so reach for it from the list item instead. */
  document.querySelectorAll('.mobile-nav__accordion-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.mobile-nav__item');
      var submenu = item && item.querySelector('.mobile-nav__submenu');
      if (!submenu) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      submenu.hidden = expanded;
    });
  });

  /* ---------------- Header search toggle ---------------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var headerSearch = document.getElementById('HeaderSearch');
  if (searchToggle && headerSearch) {
    searchToggle.addEventListener('click', function () {
      var isOpen = !headerSearch.hidden;
      headerSearch.hidden = isOpen;
      searchToggle.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) headerSearch.querySelector('input').focus();
    });
  }

  /* ---------------- Sticky header: hide on scroll down ---------------- */
  var header = document.querySelector('.site-header');
  if (header && header.dataset.sticky === 'hide-on-scroll') {
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var currentY = window.scrollY;
          if (currentY > lastY && currentY > 120) {
            header.classList.add('is-hidden');
          } else {
            header.classList.remove('is-hidden');
          }
          lastY = currentY;
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* ---------------- Announcement bar ---------------- */
  var announcementBar = document.querySelector('[data-announcement-bar]');
  if (announcementBar) {
    var dismissBtn = announcementBar.querySelector('[data-announcement-dismiss]');
    var STORAGE_KEY = 'momomoca:announcement-dismissed';
    try {
      if (sessionStorage.getItem(STORAGE_KEY)) announcementBar.style.display = 'none';
    } catch (e) { /* storage unavailable, ignore */ }

    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        announcementBar.style.display = 'none';
        try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      });
    }

    var messages = announcementBar.querySelectorAll('.announcement-bar__message');
    if (messages.length > 1 && announcementBar.dataset.autorotate) {
      var current = 0;
      var interval = parseInt(announcementBar.dataset.autorotate, 10) * 1000;
      setInterval(function () {
        messages[current].hidden = true;
        current = (current + 1) % messages.length;
        messages[current].hidden = false;
      }, interval);
    }
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartCloseEls = document.querySelectorAll('[data-cart-close]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    requestAnimationFrame(function () { cartDrawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { cartDrawer.hidden = true; }, 220);
  }
  if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);
  cartCloseEls.forEach(function (el) { el.addEventListener('click', closeCartDrawer); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && !cartDrawer.hidden) closeCartDrawer();
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshFreeShippingBar(cart) {
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10);
    var fill = bar.querySelector('.cart-drawer__shipping-fill');
    var message = bar.querySelector('[data-free-shipping-message]');
    var remaining = threshold - cart.total_price;
    var pct = Math.min(100, (cart.total_price / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (message) {
      if (remaining <= 0) {
        message.textContent = window.momomocaStrings.freeShippingUnlocked;
      } else {
        message.textContent = window.momomocaStrings.freeShippingRemaining.replace(
          '{amount}',
          formatMoney(remaining)
        );
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCartDrawer() {
    // /cart carries both the layout's drawer and the cart page section, so one
    // request re-renders whichever of the two the shopper is looking at.
    // Liquid does the money formatting, which JSON alone cannot.
    return fetch(routes.cartUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshPanel = doc.querySelector('.cart-drawer__panel');
        var panel = document.querySelector('.cart-drawer__panel');
        if (freshPanel && panel) panel.innerHTML = freshPanel.innerHTML;

        var freshPage = doc.querySelector('.cart-page');
        var page = document.querySelector('.cart-page');
        if (freshPage && page) page.replaceWith(freshPage);
      })
      .then(function () { return fetch(routes.cartGet).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshFreeShippingBar(cart);
      })
      .catch(function (err) { console.error('momomoca: cart refresh failed', err); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[action*="/cart/add"]')) return;
    e.preventDefault();
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    fetch(routes.cartAdd, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartDrawer();
        openCartDrawer();
      })
      .catch(function (err) { console.error('momomoca: add to cart failed', err); })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-qty-increase]');
    var decBtn = e.target.closest('[data-qty-decrease]');
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!incBtn && !decBtn && !removeBtn) return;

    var lineEl = e.target.closest('[data-cart-item]');
    if (!lineEl) return;
    var line = parseInt(lineEl.dataset.line, 10);
    var qtyEl = lineEl.querySelector('[data-qty-value]');
    var newQty = removeBtn ? 0 : parseInt(qtyEl.textContent, 10) + (incBtn ? 1 : -1);
    if (newQty < 0) return;

    var stepper = lineEl.querySelector('.cart-item__qty-stepper');
    if (stepper) stepper.setAttribute('aria-busy', 'true');
    if (qtyEl && !removeBtn) qtyEl.textContent = newQty;   // 즉시 반영, 아래에서 서버 값으로 덮어씀

    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartDrawer(); })
      .catch(function (err) { console.error('momomoca: cart update failed', err); });
  });

  /* ---------------- Cart page: discount code + order note ---------------- */
  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-apply-discount]');
    if (!applyBtn) return;
    var input = document.querySelector('#CartDiscount');
    var code = input && input.value.trim();
    if (!code) { if (input) input.focus(); return; }
    // the redirect below is a full page load, so say something first
    applyBtn.disabled = true;
    applyBtn.textContent = (window.momomocaStrings && window.momomocaStrings.loading) || 'Applying…';
    // /discount/<code> is the only supported way to apply a code before checkout
    window.location.href = '/discount/' + encodeURIComponent(code) +
      '?redirect=' + encodeURIComponent('/cart?discount_try=' + code);
  });

  document.addEventListener('change', function (e) {
    var note = e.target.closest('#CartNote');
    if (!note) return;
    fetch(routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(function (err) { console.error('momomoca: note save failed', err); });
  });


  /* ---------------- Welcome coupon popup ---------------- */
  var promoModal = document.querySelector('[data-promo-modal]');
  if (promoModal) {
    var promoLastFocus = null;

    function openPromo() {
      promoLastFocus = document.activeElement;
      promoModal.hidden = false;
      document.body.style.overflow = 'hidden';
      var field = promoModal.querySelector('input[type="email"]');
      if (field) field.focus();
    }
    function closePromo() {
      promoModal.hidden = true;
      document.body.style.overflow = '';
      if (promoLastFocus) promoLastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-open]')) { e.preventDefault(); openPromo(); return; }
      if (e.target.closest('[data-promo-close]')) { closePromo(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !promoModal.hidden) closePromo();
    });

    // Shopify's customer form does a real POST and sends the shopper back with
    // ?customer_posted=true. Rebuild the confirmation here rather than relying on
    // Liquid's form.posted_successfully?, which is not in scope outside {% form %}.
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      var formEl = promoModal.querySelector('.promo-modal__form');
      var code = promoModal.dataset.promoCode;
      if (formEl) {
        var parts = ['<p class="promo-modal__done" role="status">' + promoModal.dataset.promoSuccess + '</p>'];
        if (code) {
          parts.push('<p class="promo-modal__code"><span>' + code + '</span></p>');
          parts.push('<a class="btn btn--primary btn--full" href="/discount/' +
                     encodeURIComponent(code) + '?redirect=/collections/all">' +
                     promoModal.dataset.promoApply + '</a>');
        }
        formEl.innerHTML = parts.join('');
      }
      openPromo();

      // drop the flag so a refresh does not replay the confirmation
      if (window.history.replaceState) {
        var clean = window.location.pathname +
          window.location.search.replace(/([?&])customer_posted=true&?/, '$1').replace(/[?&]$/, '');
        window.history.replaceState({}, '', clean);
      }
    }
  }

  // Shopify silently ignores a code whose conditions are not met, so say why.
  var discountError = document.querySelector('[data-discount-error]');
  if (discountError) {
    var tried = (window.location.search.match(/[?&]discount_try=([^&]+)/) || [])[1];
    if (tried) {
      tried = decodeURIComponent(tried);
      var applied = Array.prototype.some.call(
        document.querySelectorAll('.cart-page__discount-row'),
        function (row) { return row.textContent.toUpperCase().indexOf(tried.toUpperCase()) > -1; }
      );
      if (!applied) {
        var minSpend = parseInt(discountError.dataset.minSpend, 10) || 0;
        var total = parseInt(discountError.dataset.cartTotal, 10) || 0;
        discountError.textContent = (minSpend && total < minSpend)
          ? '"' + tried + '" needs an order of at least $' + (minSpend / 100).toFixed(0) + '. Add a little more and try again.'
          : '"' + tried + '" could not be applied. Check the code, or it may have expired or already been used.';
        discountError.hidden = false;
      }
      if (window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname);
      }
    }
  }

  /* ---------------- Category species toggle ---------------- */
  var speciesToggle = document.querySelector('[data-species-toggle]');
  if (speciesToggle) {
    var speciesItems = document.querySelectorAll('.category-icons__item');
    function applySpecies(kind) {
      speciesItems.forEach(function (li) {
        var s = li.dataset.species;
        li.hidden = Boolean(s) && s !== kind;   // species 없는 타일은 항상 보인다
      });
      speciesToggle.querySelectorAll('[data-species-btn]').forEach(function (b) {
        b.setAttribute('aria-selected', String(b.dataset.speciesBtn === kind));
      });
    }
    speciesToggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-species-btn]');
      if (btn) applySpecies(btn.dataset.speciesBtn);
    });
    applySpecies('cat');
  }

  /* ---------------- Collection filter drawer (mobile) ---------------- */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filters-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var isOpen = filterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  /* ---------------- Collection "load more" pagination ---------------- */
  var loadMoreBtn = document.querySelector('[data-load-more]');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = loadMoreBtn.getAttribute('href');
      loadMoreBtn.textContent = window.momomocaStrings.loading || 'Loading…';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.collection-page__grid');
          var newPagination = doc.querySelector('[data-load-more]');
          var currentGrid = document.querySelector('.collection-page__grid');
          if (newGrid && currentGrid) currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
          if (newPagination) {
            loadMoreBtn.setAttribute('href', newPagination.getAttribute('href'));
            loadMoreBtn.textContent = 'Load more';
          } else {
            loadMoreBtn.remove();
          }
        });
    });
  }

  /* ---------------- Product recommendations (lazy-loaded) ---------------- */
  var recsEl = document.querySelector('[data-product-recommendations]');
  if (recsEl) {
    fetch(recsEl.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('ProductRecsGrid');
        var grid = document.getElementById('ProductRecsGrid');
        if (newGrid && grid && newGrid.children.length) grid.innerHTML = newGrid.innerHTML;
        else if (recsEl && !grid.children.length) recsEl.style.display = 'none';
      })
      .catch(function () { recsEl.style.display = 'none'; });
  }

  /* ---------------- Product share ---------------- */
  function closeShareMenus() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-share-menu]'), function (menu) {
      if (menu.hidden) return;
      menu.hidden = true;
      var t = menu.parentElement.querySelector('[data-share-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  /* clipboard API needs a secure context and a user gesture; the textarea
     fallback keeps the button honest on http previews and older Safari */
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-9999px;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
      document.body.removeChild(ta);
      ok ? resolve() : reject();
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-share-toggle]');
    var copyBtn = e.target.closest('[data-share-copy]');
    var insideMenu = e.target.closest('[data-share-menu]');

    if (toggle) {
      var wrap = toggle.closest('[data-share]');
      /* Where the browser has a share sheet, use it: it already carries the
         apps people actually share to, and it is one tap instead of two. */
      if (navigator.share) {
        navigator.share({
          title: wrap.dataset.shareTitle,
          text: wrap.dataset.shareText,
          url: wrap.dataset.shareUrl
        }).catch(function () { /* cancelled — nothing to report */ });
        return;
      }
      var menu = wrap.querySelector('[data-share-menu]');
      var opening = menu.hidden;
      closeShareMenus();
      menu.hidden = !opening;
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      return;
    }

    if (copyBtn) {
      var owner = copyBtn.closest('[data-share]');
      var label = copyBtn.querySelector('[data-share-copy-label]');
      var original = label ? label.textContent : '';
      copyText(owner.dataset.shareUrl)
        .then(function () {
          copyBtn.classList.add('is-copied');
          if (label) label.textContent = (window.momomocaStrings && window.momomocaStrings.linkCopied) || 'Link copied';
          setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            if (label) label.textContent = original;
            closeShareMenus();
          }, 1400);
        })
        .catch(function () {
          /* nothing was copied — leave the link on screen to select by hand */
          if (label) label.textContent = owner.dataset.shareUrl;
        });
      return;
    }

    if (!insideMenu) closeShareMenus();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeShareMenus();
  });

  /* ---------------- Add to home screen (phones, first visit) ---------------- */
  var a2hs = document.querySelector('[data-a2hs]');
  if (a2hs) {
    var A2HS_KEY = 'momomoca:a2hs';
    var installEvent = null;

    /* Chrome fires this when it considers the shop installable. Holding on to
       it is the only way to open the install dialog from our own button; call
       preventDefault or Chrome shows its own bar on top of the sheet. */
    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      installEvent = e;
    });

    var isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (isIOS) a2hs.classList.add('is-ios');

    function a2hsSeen() {
      try { return localStorage.getItem(A2HS_KEY) === 'done'; } catch (err) { return false; }
    }
    function a2hsRemember() {
      try { localStorage.setItem(A2HS_KEY, 'done'); } catch (err) { /* private mode */ }
    }
    function a2hsInstalled() {
      return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
        window.navigator.standalone === true;
    }
    function a2hsOpen() {
      a2hs.hidden = false;
      document.body.classList.add('a2hs-open');
      requestAnimationFrame(function () { a2hs.classList.add('is-open'); });
    }
    function a2hsClose() {
      a2hs.classList.remove('is-open');
      document.body.classList.remove('a2hs-open');
      a2hsRemember();
      setTimeout(function () { a2hs.hidden = true; }, 340);
    }

    /* Once only, on a phone, and never over the coupon popup -- landing back
       from signup with the code on screen is the worst moment to interrupt. */
    if (window.matchMedia('(max-width: 749px)').matches && !a2hsSeen() && !a2hsInstalled()) {
      setTimeout(function () {
        /* Stand down if either promo is on screen. Asking someone to install
           the shop while a product offer is open gets both of them closed
           unread; the sheet is not time-critical, so it waits for a later
           visit -- nothing is recorded, so it simply tries again next time. */
        if (document.querySelector('[data-promo-modal]:not([hidden])')) return;
        if (document.querySelector('[data-promo-pop]:not([hidden])')) return;
        a2hsOpen();
      }, 1500);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-a2hs-close]')) { a2hsClose(); return; }
      if (!e.target.closest('[data-a2hs-add]')) return;

      if (installEvent) {
        installEvent.prompt();
        installEvent.userChoice.then(function () { installEvent = null; a2hsClose(); });
        return;
      }
      /* No install API here -- iOS never has one -- so show the two taps that
         do the same job by hand. */
      a2hs.classList.add('is-howto');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !a2hs.hidden) a2hsClose();
    });

    window.addEventListener('appinstalled', function () { a2hsRemember(); });
  }

  /* ---------------- Product promo popup ---------------- */
  var promoPop = document.querySelector('[data-promo-pop]');
  if (promoPop) {
    var popKey = promoPop.dataset.key;
    var popDays = parseInt(promoPop.dataset.repeatDays, 10);
    var popDelay = (parseInt(promoPop.dataset.delay, 10) || 0) * 1000;

    function popSuppressed() {
      if (popDays === 0) return false;
      try {
        var seen = parseInt(localStorage.getItem(popKey) || '0', 10);
        if (!seen) return false;
        return (Date.now() - seen) < popDays * 86400000;
      } catch (err) { return false; }
    }
    function popRemember() {
      try { localStorage.setItem(popKey, String(Date.now())); } catch (err) { /* private mode */ }
    }
    function popOpen() {
      promoPop.hidden = false;
      document.body.classList.add('promo-pop-open');
      requestAnimationFrame(function () { promoPop.classList.add('is-open'); });
    }
    function popClose() {
      promoPop.classList.remove('is-open');
      document.body.classList.remove('promo-pop-open');
      popRemember();
      setTimeout(function () { promoPop.hidden = true; }, 300);
    }

    /* Home-page-only is the default: a popup over a product page argues with
       the thing the shopper is already reading. */
    var popScopeOk = promoPop.dataset.scope === 'all' ||
      window.location.pathname === '/' ||
      /^\/[a-z]{2}(-[a-z]{2})?\/?$/i.test(window.location.pathname);

    if (popScopeOk && !popSuppressed()) {
      setTimeout(function () {
        /* The coupon modal is the one thing that outranks this: landing back
           from signup with a code on screen is not the moment to interrupt.
           The home-screen sheet yields to us instead -- see below. */
        if (document.querySelector('[data-promo-modal]:not([hidden])')) return;
        popOpen();
      }, popDelay);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-pop-close]')) popClose();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !promoPop.hidden) popClose();
    });
    /* Following the link is a conversion, not a dismissal, but it should not
       come back at them on the next page either. */
    var popCta = promoPop.querySelector('.promo-pop__cta');
    if (popCta) popCta.addEventListener('click', popRemember);
  }

  /* ---------------- Strings (populated inline by theme.liquid if needed) ---------------- */
  window.momomocaStrings = window.momomocaStrings || {
    freeShippingUnlocked: 'You unlocked free shipping!',
    freeShippingRemaining: '{amount} away from free shipping'
  };
})();
